import React from "react";
import { Select } from "@windmill/react-ui";
const StartTimePicker = ({
  StartTimeOptions,
  handleStartTimeChange,
  register,
  name,
  label,
  selectedStartTime,
}) => {
  return (
    <>
      <Select
        className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
        {...register(`${name}`, {
          required: !selectedStartTime ? `${label} is required!` : false,
        })}
        name={name}
        value={selectedStartTime}
        onChange={(e) => handleStartTimeChange(e)}
      >
        {StartTimeOptions.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </Select>
    </>
  );
};

export default StartTimePicker;
